// extracted by mini-css-extract-plugin
export default {"text":"AnnouncementModal_text__oIpxE","field":"AnnouncementModal_field__JwXHo"};